import { types } from "../types/types";

const initialState = {
    paquete: {}
}


export const clientReducer =(state=initialState, action)=>{
    switch (action.type) {
        case types.clientLoading:
            return {
                ...state,
                ...action.payload,
            };

        case types.clientLogout:
            return initialState;
        
        case types.clientAddingRoom:
            return {
                ...state,
                habitaciones_id: action.payload
            }

        case types.clientFinishRedes:
            return {
                ...state,
                redes: action.payload
            }
        
        case types.eventsAdd:
            console.log(action.payload);
            return {
                ...state,
                eventoTemp: action.payload
            }
    
        default:
            return state;
    }
}